<template>
  <div class="flex-col footCard">
	  <div class="foot_box flex-row justify-between">
		  <div class="foot_item">
		  	 <img class="foot_item_logo" src="@/assets/home/logo@3x.png"   alt=""/>
		  </div>
		  
		  <div class="flex-col foot_item">
		    <span  class="foot_item_title">企业服务</span>
		    <span class="foot_item_content" @click="more('/recruitment', 4)">职位搜索</span>
		    <span class="foot_item_content" @click="more('/information', 1)">行业资讯</span>
		  </div> 
		  
		  <div class="flex-col foot_item">
		    <span class="foot_item_title">用户帮助</span>
		    <span class="foot_item_content" @click="agreement(1)">用户协议</span>
		    <span class="foot_item_content" @click="agreement(2)">隐私政策</span>
		    <span  class="foot_item_content" @click="agreement(3)">使用帮助</span>
		  </div>
		  
		  <div class="flex-col foot_item">
		    <span class="foot_item_title">联系方式</span>
		    <span class="foot_item_content">联系我们: {{ webConfig ? webConfig.webTelephone : '' }}</span>
		    <span class="foot_item_content">企业服务邮箱：{{ webConfig ? webConfig.webEmail : '' }}</span>
		    <span class="foot_item_content">企业地址: {{ webConfig ? webConfig.webAddress : '' }}</span>
		  </div>
		  
		  <div class="flex-col align-center foot_item">
		    <img class="foot_item_bottom_icon" v-if="webConfig && webConfig.webSmallProgramLogo" 
		    :src="webConfig.webSmallProgramLogo.indexOf('http')>-1  ? webConfig.webSmallProgramLogo : uploadImgAddress + webConfig.webSmallProgramLogo" alt=""/>
		    <img class="foot_item_bottom_icon"  v-else src="@/assets/qcode.jpg"/> 
		    <span class="foot_item_content" style="margin-top: 12px;">小程序</span>
		  </div> 
	  </div>
	  <div class="line"></div>
	  
      <!-- <div class="flex-row align-start justify-between foot1">
        
        <div class="flex-row align-end qrcode" ref="qrCodeUrl">
          <div class="flex-col">
            <img src="@/assets/qcode.png"/>
            <vue-qr 
              :size="200"
              :text=" 'http://mxwebapi.dznw.com/t?c='" :logoCornerRadius="5"
              :logoSrc="require('@/assets/logo.png')" :logoScale="0.4"
              ></vue-qr> 
            <span>微信公众号</span> 
          </div>
          <div class="flex-col">
            <img v-if="webConfig && webConfig.webSmallProgramLogo" 
            :src="webConfig.webSmallProgramLogo.indexOf('http')>-1  ? webConfig.webSmallProgramLogo : uploadImgAddress + webConfig.webSmallProgramLogo" alt=""/>
            <img v-else src="@/assets/qcode.jpg"/>
            <vue-qr 
              :size="200"
              :text="'http://clnyh5.dznw.com/'" :logoCornerRadius="5"
              :logoSrc="require('@/assets/logo.png')" :logoScale="0.4"
              ></vue-qr>
            <span>小程序</span>
          </div>
        </div>
      </div> -->
	    
		
		
      <div class="align-center justify-center  foot2">
        <div v-html="webConfig ? webConfig.webIcp : ''"></div>
        <span> {{ webConfig ? webConfig.webCopyright : '' }} </span> 
        <span> {{ webConfig ? webConfig.webTechnicalSupport : '' }} </span> 
      </div>
    </div>
</template>
<script>
import {GetWebConfig} from "@/api/common";
import VueQr  from 'vue-qr';
export default ({
  components:{
    VueQr
  },
  name: "foot",
  data(){
    return {
      webConfig: null,
      uploadImgAddress: process.env.VUE_APP_URL_IMG, // 图片显示路径
    }
  },
  mounted(){
    this.getWebConfig()
  },
  methods:{
    // 获取网站配置项
    getWebConfig(){
      GetWebConfig({}).then((res) => {
        this.webConfig = res
      });
    },
    more(path, activeIndex) {
      if(activeIndex) sessionStorage.setItem('activeIndex',activeIndex);
      if(activeIndex == 4) {
        let type = localStorage.getItem('identity') ? localStorage.getItem('identity') : '';
        if(type == 3){ //企业用户
          path = '/login';
          localStorage.clear();
          sessionStorage.clear();
        }
      }
      this.$router.push({
        path: path,
        query: {
        }
      }, () => {})
    },
    agreement(type){
      sessionStorage.setItem('activeIndex',99);
      this.$router.push({
        path: '/agreement/index/' + type,
        query: {
          type: type
        }
      }, () => {})
    }
  }
})
</script>

<style lang="scss" scoped>
@import "~@/styles/index.scss";
.foot_item{
	max-width: 20%;
}
.line{
	height: 1px; 
	background: rgba(113,122,145,0.2); 
	width: 78.5%; 
	margin: 0 auto;
}
.foot_item_bottom_icon{
	width: 76px;
	height: 76px;
	border-radius: 2px 2px 2px 2px; 
}
.foot_item_logo{
	width:85px;
	height: 26px;
}
.foot_box{
	padding: 60px 10.75%;
	// border-bottom: 1px solid rgba(113,122,145,0.2);
}
.foot_item_content{
	cursor: pointer;
	font-size: 14px;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 400;
	color: #555555;
	line-height: 18px;
	margin-bottom: 12px;
}
.foot_item_title{
	font-size: 14px;
	font-family: Microsoft YaHei, Microsoft YaHei;
	font-weight: 700;
	color: #111111;
	line-height: 18px;
	margin-bottom: 20px;
}
.footCard{
    // position: absolute;
    bottom: 0;
    width: 100%;
    .foot1{
      // width: 100%;
	  background: #F5F7FA;
      padding: 33px $padding-both;
      height: 265px;
      .footLeft{
        height: 100%;
        width: 400px;
        max-width: 530px;
        span{
         font-size: 14px;
         font-family: Microsoft YaHei, Microsoft YaHei;
         font-weight: 400;
         color: #555555;
         line-height: 18px;
          margin-bottom: 15px;
        }
        margin-right: 40px;
      }
      .partner{
        height: 100%;
        width: 380px;
        flex-wrap: wrap;
        margin-right: 40px;
        span{
          min-width: 81px;
         font-size: 14px;
         font-family: Microsoft YaHei, Microsoft YaHei;
         font-weight: 400;
         color: #555555;
         line-height: 18px;
		 
          margin-bottom: 15px;

          margin-left: 40px;
          margin-right: 45px;
          text-align: start;
          cursor: pointer;
          display: flex;
          
        }
      }
      
      .qrcode{
        flex: 1;
        margin-left: 40px;
        div{
          width: 135px;
          // margin-left: 32px;
          span{
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FEFEFE;
            text-align: center;
            margin-top: 12px;
          }
          img{
            width: 135px;
            height: 135px;
            border-radius: 10px;
          }
        }
        
      }
    }
    .el-divider--vertical{
      height: 80%;
    }
    .foot2{
      width: 100%;
      height: 94px;
      background: #F5F7FA;
	   
	  
      span, ::v-deep a{
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        line-height: 18px;
        margin-left: 5px;
      }
      ::v-deep a{
        // color: $color-theme;
        text-decoration: none;
      }
    }
  }
</style>